<div class="card-header w-100 d-flex justify-content-between">
    <h2>Recent Payments</h2>
    <span *ngIf="hasWriteAccess" [routerLink]="['/app/payments/incoming', {'recordPayment': true}]"
          class="btn btn-outline-secondary">
            <img class="plus-img" src="/assets/images/payhoa/other/plus_dark_gray.svg">Record Offline Payment
        </span>
</div>

<!-- search and date filter -->
<div class="justify-content-between d-flex align-items-center py-0 card-header card-header-bg-light">
    <div class="ml-3">
        <lf-material-search #searchInput
                            [hasGroupAddon]="false"
                            [hasButtonStyles]="true"
                            (updated)="getIncomingPayments()"></lf-material-search>
    </div>
    <report-filter-single-date-range-simple #dateFilter
                                            [doMatSelect]="true"
                                            [filterOnChange]="true"
                                            (filterReady)="filtersLoaded()"
                                            (filterResults)="getIncomingPayments()"></report-filter-single-date-range-simple>
</div>

<div class="card-body p-0">
    <div *ngIf="!isFiltersLoaded || (tableDataSource.loading$ | async)" class="card refresh-overlay">
        <div class="d-loading card-body">
            <div class="loader">Loading...</div>
        </div>
    </div>

    <app-payments-table #paymentsTable
                        [isOnDashboard]="true"
                        [hidden]="!isFiltersLoaded || (tableDataSource.loading$ | async)"
                        [selection]="selectedPayments"
                        [tableDataSource]="tableDataSource"
                        [totalRecords]="totalRecords"
                        (loadPayments)="getIncomingPayments()"></app-payments-table>
</div>


